module.exports = "//cdn.mxpnl.com/static/asset-cache/6ba244f622927c789822e3a38a44f461/iron/common/assets/images/partner-logos/avo.svg";